import React from 'react';
import {ReactComponent as ArrayLeftIcon} from '../../../../../assets/main/groups/main-table/array-left.svg';
import {MainTop} from "../../../groups/group-container/main-top/Main-top";
import AuthWrapper from "../../../../auth-wrapper/AuthWrapper";
import {TestAddItem} from "components/pages/test/test-inner-answer/test-add/test-add-item/TestAddItem";

export const TestAdd = () => {

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Создать тест'} tabs={false} setting={false} link={'/test'}
                         icons={<ArrayLeftIcon/>}/>
                <TestAddItem/>
            </div>
        </AuthWrapper>
    );
};

